import React, { useState } from "react";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import "./Quote.css";
import { navigate } from "gatsby";

const customStyles = {
  content: {
    width: "60vw",
    height: "60vh",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#202124",
    borderRadius: "5px",
    overflow: "visible",
    position: "relative",
    zIndex: "10",
  },
};

const Quote = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const [fullname, setFullName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmission = (evt) => {
    evt.preventDefault();
    var xhr = new XMLHttpRequest();
    var url =
      "https://api.hsforms.com/submissions/v3/integration/submit/8753452/c9efa58b-be84-4faf-934d-3114c2371cb1";
    var data = {
      fields: [
        {
          name: "email",
          value: email,
        },
        {
          name: "firstname",
          value: fullname,
        },
      ],
      context: {
        pageUri: "www.enviary.com",
        pageName: "Amjad Bukhari",
      },
    };

    var final_data = JSON.stringify(data);

    xhr.open("POST", url);
    // Sets the value of the 'Content-Type' HTTP request headers to 'application/json'
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        navigate(
          "https://enviary.com/many-thanks?utm_source=home-page-content-cta&utm_medium=Home%20Page%20body%20CTA%20Button&utm_campaign=Enviary's%20Internal%20Clicks%20Tracking&utm_term=enviary&utm_content=popup-form-2-homepage-creative-content"
        );
        setFullName("");
        setEmail("");
      } else if (xhr.readyState === 4 && xhr.status === 403) {
        alert(xhr.responseText); // Returns a 403 error if the portal isn't allowed to post submissions.
      } else if (xhr.readyState === 4 && xhr.status === 404) {
        alert(xhr.responseText); //Returns a 404 error if the formGuid isn't found
      }
    };

    // Sends the request
    xhr.send(final_data);
  };

  return (
    <div className="quote">
      <img
        className="img1"
        src={require("../../LandingPage/Assests/300ppi/Quote1.png")}
        alt=""
      />
      <img
        className="img2"
        src={require("../../LandingPage/Assests/300ppi/Quote2.png")}
        alt=""
      />
      <div className="quote__content">
        <h2>
          Those who do nothing,
          <br />
          do <span>Harm</span>
        </h2>

        <button onClick={() => setModalIsOpen(true)}>
          Get Klaviyo Audit Report
        </button>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="modal">
            <div className="icons" onClick={() => setModalIsOpen(false)}>
              <CancelIcon className="icon" />
            </div>
            <img
              src={require("../../LandingPage/Assests/Logo.png")}
              alt="Logo"
            />
            <h1>Get Free Klaviyo Account Audit Report</h1>
            <form onSubmit={handleSubmission}>
              <input
                type="text"
                placeholder="Your Name"
                value={fullname}
                onChange={(event) => setFullName(event.target.value)}
                required
              />
              <input
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
              <button type="submit">Get Free Klaviyo Analysis</button>
            </form>
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Quote;
